import React from "react";
import LearnMore from "../../../components/learnMore/learnMore";

const BrandLeaderBoardLearnMore = () => {
  return <LearnMore title="Brand Leaderboard" content={getContent()} html />;
};

const getContent = () => {
  return `


  The Brand Leaderboard is another way to compare your studio to the network. We have eight
   key metrics that we will use to ‘Rank’ each studio. Depending on the number of metrics
    selected (default is 4) we will rank your studio based on each metric. Then add up all
     the rankings and divide by the number of metrics to give the Total Ranking. 
    <br />
    <br />
    <h4>
        View filter:
    </h4>
    <b>Summary</b> view will only show the data for the studio selected. You will not be able
     to see any other studios data, besides what we show in the ‘Top 3’ studio list. This is the default view. 
    <br />
    <b>Details view</b> will allow the user to see how the rest of the networks ranks. <i>This view is an organization 
    wide setting and may not be available for store level use.</i>
    <br />
    <br />
    <b>Metrics</b> Allows you to select the metrics from the dropdown list. You must have at least one metric 
    for the calculation to work. We will only calculate rankings based on the metrics you select. The default
     is four metrics but you can add more or select less. 
    <br />
    <br />
    <b>Date:</b> This calendar control is in monthly only mode. You cannot select a specific date, only months.
     For the current month, the data used for rankings will only be month-to-date.
    <br />
    <br />
    <br />
    <b>Total Ranking:</b> Once we have added up all the rankings from the metrics selected, this will show you
     where your store ranks against the network.   
     <br />
     <br />
     <b>Previous Ranking:</b> This will display only if you are on the current month. Showing where the store 
     ranked the previous month. If you select a month other than the current for the start, this value will not show. 
     <br />
     <br />
     <b>Top 3</b> Based on the rankings, we will display the three stores that ranked the highest overall.
     <br />
     <br />
     <b>Bottom 3</b> Based on the rankings, we will display the three stores that ranked the lowest overall.
     <br />
     <br />   
     <br />
     Metrics available. When looking at any data in a prior month, we will use the last day of the months data for calculations. 
     <br />
     <br />
     <b>Leads (default)</b> We will count all the Leads (profiles created) during the date range selected then rank each store based on their number. 
     <br />
     <b>Enrollments (default)</b> We will count all the Enrollments (conversions based on mapping) during the date range selected then rank 
     each store based on their number.
     <br />
     <b>Members (default)</b> We will count all the Members (based on the membership logic settings) during the date range 
     selected then rank each store based on their number.
     <br />
     <b>Attrition Rate</b> We will show the attrition rate from the date range selected then rank each store based on 
     their number. This is the only number where the lower you are, the better. 
     <br />
     <b>New Members</b> We will count all the New Members during the date range selected then rank each store based on their number.
     <br />
     <b>First Visits</b> We will count all the First Visits (completed bookings only) during the date range selected
      then rank each store based on their number.
      <br />
     <b>Gross Revenue</b> We will count all the Gross Revenue during the date range selected then rank each store
      based on their number.
      <br />
     <b>Utilization (default)</b> We will show Utilization (completed bookings only) during the date range 
     selected then rank each store based on their number.
    `;
};

export default BrandLeaderBoardLearnMore;
